import { Language } from 'store/slices/language-slice';

interface messageTypes {
  country: string;
  phoneNumber: string;
}

type Message = {
  [key in Language]: messageTypes;
};

const messages: Message = {
  en: {
    country: 'Country',
    phoneNumber: 'Phone number',
  },
};

export default messages;
